import { Col, Empty, Space, Tag, Typography } from "antd";
import { KanbanCard } from "./KanbanCard";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";

const { Title } = Typography;

interface KanbanLaneProps {
  title: string;
  dossiers: Dossier[];
}

export const KanbanLane = ({ title, dossiers }: KanbanLaneProps) => {
  return (
    <Col xs={24} sm={24} md={16} lg={12} xl={8} xxl={6}>
      <div className="flex flex-col h-[calc(100vh-240px)] border border-gray-200 rounded-xl overflow-hidden bg-white mb-3">
        <div className="sticky top-0 z-10 bg-white border-b border-gray-200 p-3">
          <Space className="w-full justify-between" align="center">
            <Title level={5} style={{ margin: 0 }}>
              {title}
            </Title>
            <Tag bordered={false} className="bg-gray-100 rounded-full">
              {dossiers.length}
            </Tag>
          </Space>
        </div>
        <div style={{ padding: 12, overflow: "auto" }}>
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            {dossiers.length ? (
              dossiers.map((dossier) => (
                <KanbanCard key={dossier.id} dossier={dossier} />
              ))
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Geen dossiers aanwezig"
              />
            )}
          </Space>
        </div>
      </div>
    </Col>
  );
};
